import { Component } from '@angular/core';
import{CommonModule} from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UsersService } from '../services/users.service';
import { Router } from '@angular/router';
import { RequestPassword } from '../models/RequestPassword';
import { LoaderComponent } from "../utils/loader/loader.component"
import { ToastService } from '../services/toast.service';
import { NgxMaskDirective,  provideNgxMask } from 'ngx-mask';
import { passwordStrengthValidator } from '../passwordValidator';
import { ButtonModule } from 'primeng/button';
import { ThemeService } from '../theme.service';






@Component({
    selector: 'app-change-password',
    imports: [ButtonModule, CommonModule, ReactiveFormsModule, FormsModule, LoaderComponent, NgxMaskDirective],
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss',
    providers: [provideNgxMask()]
})


export class ChangePasswordComponent {
formPassword !: FormGroup;
passwordType0 = 'password';
passwordType1 = 'password';
passwordType2 = 'password';
showPassword0 = false;
showPassword1 = false;
showPassword2 = false;
isLoader:boolean= false
msgError: string = '';
inProcess!:boolean

data: any;
msgModalAlert:string=''
showModalAlert!:boolean
pattern = {
  K: {
   // pattern: new RegExp("[a-zA-Z0-9\@\$!%*?&._#]"), 
   pattern: new RegExp("[^\\s]"),  
   optional: true
  },
}

  constructor(private service:UsersService, private themeService: ThemeService, private toastSrv: ToastService, private router: Router){
    
  
    this.data = JSON.parse(localStorage.getItem('data')!); 

    
  this.formPassword = new FormGroup({   
    oldPassword: new FormControl({value:"", disabled: false}, [Validators.required]),
    password:  new FormControl({value:"", disabled: false}, [Validators.required,passwordStrengthValidator]),
    newPassword:  new FormControl({value:"", disabled: false}, [Validators.required,passwordStrengthValidator])
  })
}



togglePasswordVisibility0() {
  this.showPassword0 = !this.showPassword0;
  this.passwordType0 = this.showPassword0 ? 'text' : 'password';
}

  togglePasswordVisibility1() {
    this.showPassword1 = !this.showPassword1;
    this.passwordType1 = this.showPassword1 ? 'text' : 'password';
  }

  togglePasswordVisibility2() {
    this.showPassword2 = !this.showPassword2;
    this.passwordType2 = this.showPassword2 ? 'text' : 'password';
  }

  confirmAction(){
    if(this.oldPassword!.value=='' || this.password!.value=='' ||this.newPassword!.value=='' ){

       this.msgError ='Las contraseñas no pueden estar vacías.'
    }    
    
    else{
      this.msgError = '';
      let request = new RequestPassword();
      request.clientNumber = this.data.Client_number;
      request.userId = this.data.User_id==0?null:this.data.User_id;
      request.oldPassword = this.oldPassword!.value;
      request.password = this.password!.value;
      request.newPassword = this.newPassword!.value;
      this.userPassword(request);

    }   

  }

  get oldPassword(){
    return this.formPassword.get('oldPassword') ;
  }
  get password(){
    return this.formPassword.get('password') ;
  }
  get newPassword(){
    return this.formPassword.get('newPassword') ;
  }

  onCancel(){
 
    this.showModalAlert = false

  }

  ngOnInit() {
    this.themeService.setTitle('Cambiar Contraseña');
    this.reset();
  }

  userPassword(request : RequestPassword):void{
    this.inProcess = true;
    this.service.userPassword(request).subscribe({
      next: (data: any) => {
        if(data.isValid){          
        this.reset();
        this.toastSrv.add({ type: 'success', message: data.message });
        setTimeout(() => this.router.navigate(['/login']), 2000);
      }
      else if(data.isValid == false){
        this.msgError = data.message;
      }   
      else{
        this.msgError = data.error
      }
            
      this.inProcess = false;
    },
    error: (err: any) => {
      this.msgError=err;
      this.inProcess = false;
    }      
  }); 
  }

  reset(){
    this.formPassword.reset({
      oldPassword: '',
      password: '',
      newPassword: ''
    });
  }

}
